export var AV_FRONTEND_SUMMARY_ENDPOINT = '/summary/';
export var AV_FRONTEND_INIT_CAPTURE_ENDPOINT = '/init_capture/';
export var AV_FRONTEND_UPLOAD_CONFIRMATION_ENDPOINT = '/upload_confirmation/';
export var FLOW_QUERY_PARAMETER = 'flow';
export var TOKEN_QUERY_PARAMETER = 'token';
export var TOKEN_SOURCE_QUERY_PARAMETER = 'tokenSource';
export var TOKEN_SOURCE_F3D6 = 'f3d6';
export var TOKEN_VALID_LENGTH = 160;
export var TOKEN_VALID_LENGTH_F3D6 = 36;
export var HTTP_STATUS_CODE_TOKEN_EXPIRED = 401;
export var HTTP_STATUS_CODE_VERIFICATION_ERROR = 404;
export var CUSTOMER_HELP_LINK = 'https://help.williamhill.com/hc/en-gb/articles/21812894222109-Account-Verification-Guide';
export var AxiosRequestMethod = {
    POST: 'post',
    GET: 'get',
};
//# sourceMappingURL=constants.js.map